import { FadeUp } from './Motion.jsx';

export default function KeyFacts({ title = 'Key facts', items }) {
  return (
    <FadeUp>
      <aside className="keyfacts" aria-label={title}>
        <h2 className="keyfacts-title">{title}</h2>
        <dl className="keyfacts-list">
          {items.map((f) => (
            <div key={f.label} className="keyfacts-item">
              <dt className="keyfacts-label">{f.label}</dt>
              <dd className="keyfacts-value">{f.value}</dd>
            </div>
          ))}
        </dl>
      </aside>
    </FadeUp>
  );
}